import React from "react";

import { BulkEditActivity } from "app/userManagement/modules/generic";

const ProviderBulkEditActivity = () => {
  return <BulkEditActivity />;
};

export default ProviderBulkEditActivity;
